<em-box class="relative shadow-sm" size="sm">
  @if (inProgress$ | async) {
    <em-spinner
      [overContent]="true"
      class="em-spinner-mini"
      style="height: 100%"
      [label]="('PROGRESS_ACTION_RUNNING' | translate) + '...'"
    ></em-spinner>
  }

  <div class="flex gap-4 items-center">
    <div class="flex flex-col gap-1">
      <em-fetch-products-info-text></em-fetch-products-info-text>
    </div>

    <em-secondary-button (btnClick)="triggerFetch()" icon="update">
      {{ 'PROGRESS_STATE_IDLE' | translate }}
    </em-secondary-button>
  </div>
</em-box>
